//Coverts to a blob and then creates an object url that opens in a separate window

export function openPdfFromBase64(b64Pdf: string) {
    const base64ContentOnly = stripDataUrlPrefix(b64Pdf);

    try {
        const decoded = atob(decodeURIComponent(base64ContentOnly));
        const byteNumbers = Array.from(decoded, c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
    } catch (err) {
        console.error("Failed to decode base64 PDF:", err);
        console.error("Raw string:", base64ContentOnly);
        alert("Invalid base64 data. See console.");
    }
}



export function fileToBase64(file: File) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result); // Full Data URL (e.g., data:image/png;base64,...)
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(file); // Reads file as base64 encoded Data URL
    });
}




export function stripDataUrlPrefix(base64String:string) {

    const clean = base64String.replace(/^data:.*;base64,/, "").replace(/^base64/, "").trim();

    // Ensure it's not URL-encoded
    try {
        return decodeURIComponent(clean);
    } catch (e) {
        // Not URL encoded, just return as-is
        return clean;
    }
}

